<div
  class="flex w-full h-full"
  appPosition [position]="
  {
    top: component().properties.position.y,
    left: component().properties.position.x
   }"
  [ngStyle]="{
        'background-color': 'transparent',
        'width.px':component().properties.size.width ,
        'height.px':component().properties.size.height ,
        }"
>
  <lib-slider [slides]="component().properties.itemCarousel ?? []"></lib-slider>
</div>
